import { useTheme } from "@mui/material/styles";
import { useState, useEffect, useRef, lazy, Suspense } from "react";
import ProfileMenu from "../../../components/common/ProfileMenu";
import WhiteBJSEnglish1 from "../../../images/WhiteBJSEnglish1.svg";
import {
  AppBar,
  Box,
  Toolbar,
  Button,
  Typography,
  Dialog,
  DialogContent,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import useMediaQuery from "@mui/material/useMediaQuery";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from '@mui/icons-material/Download';
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";


const AuthModal = lazy(() => import("../../VM/LoginPage/AuthModal/AuthModal"));

const navButtons = [
  { label: "About VMS" },
  // { label: "LMS" },
  { label: "PMS" },
  // { label: "BJS Darpan" },
  { label: "BJS Website" },
];

export default function AppHeader() {
  const theme = useTheme();
  const joinButtonRef = useRef(null);
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [open, setOpen] = useState(false);
  const [joinModalOpen, setJoinModalOpen] = useState(false);
  const [entryMode, setEntryMode] = useState("join");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [profileAnchor, setProfileAnchor] = useState(null);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const [language, setLanguage] = useState("english");
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  
  const location = useLocation();
  const isDastak = location.pathname.includes("dastak");
  const isDastakLandingPage = 
  location.pathname.includes("landingpage") ||
  location.pathname.includes("registerNewUser");

  const isLoggedIn = Boolean(localStorage.getItem("accessToken"));
  // need to add a check for navigated from (coming-soon) then show Login/Register instead of Go To Dashboard.

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const handleJoinModalOpen = () => {
    setEntryMode("join");
    setJoinModalOpen(true);
  };

  const handleJoinModalClose = () => {
    setJoinModalOpen(false);
    setEntryMode("join");
  };

  const handleNavButtonClick = (label) => {
    if (label === "About VMS") {
      setOpen(true);
      return;
    }
    if (label === "BJS Website") {
      window.open("https://bjsindia.org/", "_blank");
      return;
    }
    // if (label === "LMS") {
    //   window.open("http://13.126.188.141/", "_blank");
    //   return;
    // }
    // if (label === "BJS Darpan") {
    //   window.open("https://bjsindia.org/Darpan.html", "_blank");
    // }
  };

  const aboutContent = {
    english: {
      button: "Hindi",
      title: "About Volunteer Management System",
      description:
        "The Volunteer Management System (VMS) is the digital backbone of BJS’s nationwide volunteer network. Built to streamline coordination across 500+ chapters, VMS empowers volunteers, leaders, and chapters with structured communication, seamless program management, and efficient collaboration, enabling greater impact in community development and nation-building.",
      subTitle: "Enable Users To",
      points: [
        "Explore and navigate the complete BJS volunteer and chapter network through one unified platform ",
        "Gain a deeper understanding of all BJS programs, initiatives, and areas of impact",
        "Stay updated with a centralized calendar of upcoming events, meetings, trainings, and activities",
        "Connect seamlessly with BJS leadership across chapters, districts, regions, and states",
        "Access real-time nationwide updates, achievements, and impact stories from BJS programs across India",
      ],
    },

    hindi: {
      button: "English",
      title: "वॉलंटियर मैनेजमेंट सिस्टम",
      description:
        "वॉलंटियर मैनेजमेंट सिस्टम (VMS), BJS के राष्ट्रव्यापी वॉलंटियर नेटवर्क की डिजिटल शक्ति है, 500+ चैप्टर्स के समन्वय को सरल और प्रभावी बनाने के लिए तैयार किया गया यह प्लेटफ़ॉर्म, वॉलंटियर्स, लीडर्स और चैप्टर्स को बेहतर संवाद, सुचारु प्रोग्राम मैनेजमेंट और प्रभावी सहयोग की सुविधा प्रदान करता है, ताकि समाज विकास और राष्ट्र निर्माण के कार्यों को और अधिक प्रभावशाली बनाया जा सके।",

      subTitle:
        "वॉलंटियर मैनेजमेंट सिस्टम उपयोगकर्ताओं को सक्षम बनाएगा",

      points: [
        "एकीकृत प्लेटफ़ॉर्म के माध्यम से सम्पूर्ण BJS वॉलंटियर एवं चैप्टर नेटवर्क को समझने और उससे जुड़ने में",
        "BJS के सभी प्रोग्राम्स, पहल और उनके प्रभाव की गहन जानकारी प्राप्त करने में",
        "आगामी कार्यक्रमों, बैठकों, प्रशिक्षणों और गतिविधियों के कैलेंडर से लगातार अपडेट रहने में",
        "चैप्टर, जिला, क्षेत्र एवं राज्य स्तर के BJS नेतृत्व से सहज रूप से जुड़ने में",
        "पूरे भारत में चल रहे BJS कार्यक्रमों की रियल-टाइम अपडेट्स, उपलब्धियों और प्रभाव की जानकारी प्राप्त करने में",
      ],
    },
  };

  const selectedContent = aboutContent[language];

  const handleVMSDownload = async () => {
  if (!deferredPrompt) {
    console.log("Installation prompt is not available.");
    return;
  }
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  console.log(`User choice: ${outcome}`);
  setDeferredPrompt(null);
};


  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          backgroundColor: "#0A0A0A",
          boxShadow: "none",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
          zIndex: 1200,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            px: { xs: 0, sm: 2, md: 3, lg: 4 },
            minHeight: 70,
            // px: { xs: 1.25, sm: 2, md: 3 }, 
            minHeight: { xs: 62, sm: 66, md: 70 },
          }}
        >
          {/* LEFT SECTION */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.8 }}>
            {!isMobile && (
              
              <Box sx={{display:"flex", flexDirection:"row", gap:{ md:"10px", lg:"12px"}}}>
                <Box
                  component="img"
                  src={WhiteBJSEnglish1}
                  alt="Logo"
                  onClick={() => isDastak? navigate("/dastak/homepage") : navigate("/")}
                  sx={{
                    height: 40,
                    // height: { xs: 28, sm: 34, md: 40 }, from ruchika.
                    cursor: "pointer",
                  }}
                />

                <Typography
                  sx={{
                    color: "#ffffff",
                    fontSize: { md: "14px", lg: "16px" },
                    fontWeight: 500,
                    letterSpacing: 0.3,
                    alignContent:"center",
                    whiteSpace: "nowrap",
                    display: isDastak ? "none" : "block",
                    // overflow: "hidden",
                    // textOverflow: "ellipsis",
                    maxWidth: { md: 260, lg: 420 },
                  }}
                >
                  Volunteer Management System
                </Typography>
                </Box>
              )}
          </Box>

          {/* RIGHT SECTION */}
          {/* <Box sx={{ display: "flex", alignItems: "center", justifyContent: {xs:"space-between"}, gap: 2, width:"100%", px:{xs:2, sm:2} }}> */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, justifyContent: { xs: "space-between" }, width: { xs: "100%", md: "auto" } }}>
            {!isMobile ? (
              <>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
                  {navButtons.map((item) => (
                    <Button
                      key={item.label}
                      onClick={() => handleNavButtonClick(item.label)}
                      sx={{
                        color: "#ffffff",
                        backgroundColor: "#000000",
                        border: "1px solid rgba(255,255,255,0.6)",
                        textTransform: "none",
                        fontSize: "13.5px",
                        fontWeight: 500,
                        height: 36,
                        px: 2.8,
                        borderRadius: "999px",
                        boxShadow: "none",
                        backdropFilter: "blur(6px)",
                        transition: "all 150ms ease",
                        display: isDastak? "none" : "block",
                        "&:hover": {
                          backgroundColor: "#24034F",
                          borderColor: "#ffffff",
                        },
                      }}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>

                <Button
                  ref={joinButtonRef}
                  onClick={isLoggedIn ? () => navigate("/dashboard") : handleJoinModalOpen}
                  sx={{
                    background: "linear-gradient(90deg, #7B2FF7, #9E4DFF)",
                    color: "#fff",
                    textTransform: "none",
                    fontSize: { xs: "12px", sm: "14px" },
                    fontWeight: { xs: "400", sm: "600" },
                    px: { xs: 1, sm: 3 },
                    height: { xs: 26, sm: 38 },
                    borderRadius: "999px",
                    minWidth: "unset",
                    display: isDastak? "none" : "block",
                    "&:hover": {
                      opacity: 0.9,
                    },
                  }}
                >
                  {isLoggedIn ? "Go to Dashboard" : "Login / Register"}
                </Button>
              </>
            ) : (
              <Box sx={{
                display: "flex",
                flexDirection: { xs: "row", sm: "row", md: "row" },
                alignItems: { xs: "flex-start", sm: "center" },
                gap: { xs:"6px", sm: "10px" },
                width: { xs: "100%" },
                px: { xs: 0.5 },
                py: { xs: 0.5 }
              }}
              >
                <Box
                  component="img"
                  src={WhiteBJSEnglish1}
                  alt="Logo"
                  sx={{
                    height: { xs: 24, sm: 32 },
                    cursor: "pointer",
                  }}
                />
                <Typography
                  sx={{
                    color: "#ffffff",
                    fontSize: { xs: "4px", sm: "12px", md: "14px", lg: "16px" },
                    fontWeight: 500,
                    letterSpacing: 0.3,
                    whiteSpace: "nowrap",
                    alignItems:"center",
                    // overflow: "hidden",
                    // textOverflow: "ellipsis",
                    display: isDastak? "none" : "block",
                    maxWidth: { md: 260, lg: 420 },
                  }}
                >
                  Volunteer Management System
                </Typography>
              </Box>
            )}

            {isDastak && !isDastakLandingPage && (
              <Box sx={{ alignSelf: "flex-end" }}>
                <ProfileMenu />
              </Box>
            )}

            {/* Install VMS - only on mobile */}
            {isMobile && (<Button variant="text" size="small" sx={{color:"white", display:"flex", flexDirection:"column", fontSize:"10px"}} onClick={handleVMSDownload}>
              <DownloadIcon/>
              Install VMS?
            </Button>)}

            {/* HAMBURGER ICON - only on mobile */}
            {isMobile && (
              <IconButton
                color="inherit"
                onClick={() => setDrawerOpen((pre)=> !pre)}
                sx={{
                  ml: 1,
                  fontSize:"1rem !important",
                  display: isDastak? "none" : "block",
                  border: "1px solid rgba(255,255,255,0.4)",
                  borderRadius: "50%",
                  background: "#1a1a1a",
                  "&:hover": { background: "#333" },
                }}
              >
                {drawerOpen ? <CloseIcon /> : <MenuIcon />}
              </IconButton>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      {/* DRAWER FOR MOBILE NAV */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            display: isDastak? "none" : "block",
            width: 260,
            background: "#0A0A0A",
            color: "#fff",
            p: 2,
          },
        }}
      >
        {/* <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
          <IconButton onClick={() => setDrawerOpen(false)} color="inherit">
            <CloseIcon color="#fff" />
          </IconButton>
        </Box> */}
        <Divider sx={{ my:4, borderColor: "rgba(255,255,255,0.1)" }} />
        {navButtons.map((item) => (
          <Button
            key={item.label}
            onClick={() => {
              handleNavButtonClick(item.label);
              setDrawerOpen(false);
            }}
            sx={{
              display: isDastak? "none" : "block",
              color: "#fff",
              justifyContent: "flex-start",
              width: "100%",
              mb: 1.5,
              background: "#000000",
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: "999px",
              textTransform: "none",
              fontSize: "15px",
              fontWeight: 500,
              px: 2,
              "&:hover": {
                background: "#7B2FF7",
                borderColor: "#fff",
              },
            }}
          >
            {item.label}
          </Button>
        ))}

        <Button
          onClick={() => {
            handleJoinModalOpen();
            setDrawerOpen(false);
          }}
          sx={{
            color: "#fff",
            justifyContent: "center",
            width: "100%",
            mt: 2,
            background: "linear-gradient(90deg, #7B2FF7, #9E4DFF)",
            border: "none",
            borderRadius: "999px",
            textTransform: "none",
            fontSize: "15px",
            fontWeight: 500,
            px: 2,
            py: 1.1,
            display: isDastak? "none" : "block",
            "&:hover": {
              opacity: 0.95,
              background: "linear-gradient(90deg, #8C3BFF, #AE63FF)",
            },
          }}
        >
        {isLoggedIn ? "Go to Dashboard" : "Login / Register"}
      </Button>
      </Drawer>

      {/* AUTH MODAL */}
      <Suspense fallback={null}>
        <AuthModal
          open={joinModalOpen}
          onClose={handleJoinModalClose}
          anchorRef={joinButtonRef}
          entryMode={entryMode}
        />
      </Suspense>

      {/* ABOUT DIALOG */}
      {/* <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth sx={{ borderRadius: "8px" }}>
        <DialogContent sx={{ p: 3, position: "relative" }}>
          <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
            <Button onClick={() => setSelectedLanguage((prev) => (prev === 0 ? 1 : 0))}>
              {selectedLanguage.toString()}
            </Button>
            <IconButton
              onClick={() => setOpen(false)}
              sx={{ position: "absolute", top: 8, right: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box className="d-flex flex-col items-start">
            <Typography variant="h4" fontWeight="bold" mb={1} textAlign="center">
              About Volunteer Management System
            </Typography>
            <Typography variant="h6" color="text.secondary" mb={2}>
  
            </Typography>
            <Typography variant="h4" fontWeight="bold" mb={1} textAlign="center">
              Enable Users To
            </Typography>
            <ul>
              <li> • Explore and navigate the complete BJS volunteer and chapter network through one unified platform </li>
              <li> • Gain a deeper understanding of all BJS programs, initiatives, and areas of impact </li>
              <li> • Stay updated with a centralized calendar of upcoming events, meetings, trainings, and activities </li>
              <li> • Connect seamlessly with BJS leadership across chapters, districts, regions, and states </li>
              <li> • Access real-time nationwide updates, achievements, and impact stories from BJS programs across India </li>
            </ul>
          </Box>
        </DialogContent>
      </Dialog> */}


      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth={false}
        sx={{
          "& .MuiDialog-container": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },

          "& .MuiPaper-root": {
            margin: "0 !important",
            width: "92vw",
            maxWidth: "1200px",
            background: "transparent",
            boxShadow: "none",
            overflow: "visible",
            display: "flex",
            justifyContent: "center",
          },
        }}
      >
        <DialogContent
          sx={{
            p: "0 !important",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: "100%",
              minHeight: "390px",
              borderRadius: "12px",
              p: { xs: 3, md: 4.5 },
              position: "relative",
              overflow: "scroll",
              background: language === "hindi" ? "#F2E7FF" : "#FFF4D7",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: 10,
                right: 18,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Button
                onClick={() =>
                  setLanguage((prev) =>
                    prev === "english" ? "hindi" : "english"
                  )
                }
                sx={{
                  textTransform: "none",
                  minWidth: "105px",
                  height: "40px",
                  margin: "10px",
                  borderRadius: "10px",
                  fontSize: "16px",
                  fontWeight: 500,
                  background: "#F8F8F8",
                  color: "#000",

                  "&:hover": {
                    background: theme.palette.primary.main,
                  },
                }}
              >
                {selectedContent.button}
              </Button>

              <IconButton
                onClick={() => setOpen(false)}
                sx={{
                  width: 40,
                  height: 40,
                  color: "#5A5A5A",
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {/* CONTENT */}
            <Box
              sx={{
                width: "100%",
                maxWidth: "1120px",
                mt: { xs: 5, md: 1 },
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 800,
                  lineHeight: 1.15,
                  mb: 2.5,
                  color: "#111",
                }}
              >
                {selectedContent.title}
              </Typography>

              <Typography
                variant="body1 !important"
                sx={{
                  maxWidth: "1120px",
                  mb: 3,
                  color: "#000",
                }}
              >
                {selectedContent.description}
              </Typography>

              <Typography
                variant="h3"
                sx={{
                  fontWeight: 800,
                  lineHeight: 1.2,
                  my: 2.5,
                  color: "#111",
                }}
              >
                {selectedContent.subTitle}
              </Typography>

              <Box
                component="ul"
                sx={{
                  pl: 3,
                  m: 0,
                  display: "flex",
                  flexDirection: "column",
                  gap: 0.8,
                }}
              >
                {selectedContent.points.map((item, index) => (
                  <Typography
                    key={index}
                    variant="body1"
                    component="li"
                    sx={{
                      lineHeight: 1,
                      color: "#111",
                    }}
                  >
                    • {item}
                  </Typography>
                ))}
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )

}
